import React from 'react';
import { Modal, Image } from 'antd';
import { FileOutlined, FilePdfOutlined, FileWordOutlined } from '@ant-design/icons';
import { FileMetadata } from '@/types/missing-types';
import { formatFileSize } from '@/utils/fileUtils';
import { formatDate } from '@/utils/date';
import { PreviewContainer, FileInfo } from './styles/FilePreview.styles';

interface FilePreviewProps {
  file: FileMetadata;
  visible: boolean;
  onClose: () => void;
}

const FilePreview: React.FC<FilePreviewProps> = ({ file, visible, onClose }) => {
  const fileType = file.mimeType || file.type;

  const getFileIcon = () => {
    switch (fileType) {
      case 'application/pdf':
        return <FilePdfOutlined style={{ fontSize: 48, color: '#ff4d4f' }} />;
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return <FileWordOutlined style={{ fontSize: 48, color: '#1890ff' }} />;
      default:
        return <FileOutlined style={{ fontSize: 48 }} />;
    }
  };

  const isImage = fileType.startsWith('image/');

  return (
    <Modal
      title="Предпросмотр файла"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <PreviewContainer>
        {isImage ? (
          <Image src={file.url} alt={file.name} style={{ maxWidth: '100%' }} />
        ) : (
          getFileIcon()
        )}
        <FileInfo>
          <div className="file-name">{file.name}</div>
          <div className="file-details">
            {formatFileSize(file.size)} • {formatDate(file.createdAt)}
          </div>
        </FileInfo>
      </PreviewContainer>
    </Modal>
  );
};

export default FilePreview;